<template>    
  <a href="#colorlib-main" class="skip-link" v-html="languageData['skipContent']" id="skip-content"></a>    
</template>

<script>
export default {
    name: 'SkipToMainContent',
    data(){
        return{            
            CONTENT_DOMAIN:this.$store.state.CONTENT_DOMAIN
        };
    },
    computed:{
       languageData(){return this.$store.state.languageData;}       
    },
    mounted :function(){
            // this.events.forEach(function(event) {
            //     window.addEventListener(event, this.resetTimer);
            // },this);
    },
	  methods:{
        
    }
};
</script>
<style scoped>
.skip-link {
  background: #fff;
  color: #000;
  font-weight: 700;
  /* left: 50%; */
  padding: 4px;
  position: absolute;
  transform: translateY(-90px);/*-100% */
}

.skip-link:focus {
  transform: translateY(0%);
  border: 2px solid #ab1d07;
  z-index: 9999!important;
}
.skip-link {
  /* Same as  before */
  transition: transform 0.3s;
}
</style>